<div class="p-2 flex justify-content-between flex-wrap">
  <span class="text-xs font-medium uppercase">
    {{ title }}
  </span>
  <div *ngIf="closable" class="flex align-items-center justify-content-center">
    <mat-icon
      (click)="onCloseClick()"
      class="text-base cursor-pointer material-symbols-outlined"
      inline
    >
      close
    </mat-icon>
  </div>
</div>

<div mat-dialog-content class="py-1">
  <ng-content select="[content]" class="flex flex-column gap-2"></ng-content>
</div>

<div mat-dialog-actions align="end">
  <ng-content select="[footer]"></ng-content>
</div>
